export const InvoiceVolumeGroupStatusEnum = Object.freeze({
    IN_PROGRESS: 1,
    FINISHED: 2,
    COMPLETED_WITH_SHORTAGE: 3,
    UNGROUPED: 4
});

export const DeviceSizeEnum = Object.freeze({
    XS: 0,
    SM: 1,
    MD: 2,
    LG: 3,
    XL: 4
});

export const ManagementStatusEnum = Object.freeze({
    IN_NEGOTIATION: 1,
    SOLD: 2,
    COLLECTED: 3,
});

export const ParamTipoAreaEnum = Object.freeze({
    RECEBIMENTO: 1,
    TRIAGEM: 2,
    INVENTARIO: 99,
});

export const InvoiceVolumeStatusEnum = Object.freeze({
    INVENTORY_MANAGEMENT_IN_PROGRESS: 6,
    INVENTORY_MANAGEMENT_UNGROUPED: 5,
});

/*
 * Espelha App\Enums\Carga\StatusProcessoEnum do isend-backend.
 * Chega no payload da Expedição em `statusProcessoExpedicao.valor`.
 * Não confundir com StatusExpedicaoNstechEnum: o valor 3 coincide nos dois.
 */
export const StatusProcessoExpedicaoEnum = Object.freeze({
    PENDENTE: 1,
    EM_ANDAMENTO: 2,
    CONCLUIDO: 3,
    ERRO: 4,
});

/*
 * Espelha App\Enums\Carga\StatusCargaEnum do isend-backend.
 * Chega no payload da Expedição em `status.valor`.
 */
export const StatusCargaEnum = Object.freeze({
    GERADA: 1,
    PENDENTE: 2,
    EXPEDIDA: 3,
    INATIVA: 4,
    TRANSFERIDA: 5,
    FINALIZADA: 6,
});